import PropTypes from 'prop-types';
import React from 'react';
import UserNote from 'components/UserNote';
import PhaseType from 'types/phase';

const specialOptionsRender = (specialOptions) => {
  const { rushRequestNote, commercialRefigure, rushRequest } = specialOptions;
  return (
    <div>
      {rushRequest && <span><strong>Rush Request</strong></span>}
      {commercialRefigure && <span> <strong>Commercial Refigure</strong></span>}
      {rushRequest && <UserNote><strong>Reason:</strong> {rushRequestNote}</UserNote>}
    </div>
  );
};

const storeInfoRender = storeInfo =>
  <div>
    <div><strong>Request by:</strong> {storeInfo.associateName}</div>
    <div><strong>Email:</strong> {storeInfo.associateEmail}</div>
  </div>;

const refigureDetailsRender = refigureDetails =>
  refigureDetails.map(detail =>
    <div key={detail.id}>
      <br />
      <div><strong>Surface Type:</strong> {detail.surface_type.value}</div>
      <div><strong>Project SqFt:</strong> {detail.sqft}</div>
      {Object.keys(detail.surface_information).sort().map(key =>
        <div key={key}>
          <strong style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}: </strong>
          {detail.surface_information[key]}
        </div>,
      )}
      {detail.roomName && <div><strong>Room Name:</strong> {detail.roomName}</div>}
      {detail.specialInstructions &&
        <div><strong>Special Instructions:</strong> {detail.specialInstructions}</div>}
    </div>,
  );

export const refigure_request = ({ event: { kind, data: { refigureDetails,
  specialOptions, storeInfo } } }) =>
    <div className={kind}>
      {specialOptionsRender(specialOptions)}
      {storeInfoRender(storeInfo)}
      {refigureDetailsRender(refigureDetails)}
    </div>;

refigure_request.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      refigureDetails: PropTypes.object.isRequired,
      specialOptions: PropTypes.object.isRequired,
      storeInfo: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/refigure_request.jsx